import { useState } from "react";
import { toast } from "sonner";
import { adminApi } from "@/lib/api";

export const useCrud = (resource, items, setItems) => {
  const [editing, setEditing] = useState(null);
  const [query, setQuery] = useState("");
  const [saving, setSaving] = useState(false);

  const filtered = items.filter((it) => {
    const q = query.trim().toLowerCase();
    return !q || (it.name || it.title || "").toLowerCase().includes(q) || (it.category || "").toLowerCase().includes(q);
  });

  const save = async (payload, validate) => {
    const err = validate?.(payload);
    if (err) return toast.error(err);
    setSaving(true);
    try {
      const res = editing?.id ? await adminApi.put(`/${resource}/${editing.id}`, payload) : await adminApi.post(`/${resource}`, payload);
      setItems((xs) => (editing?.id ? xs.map((x) => (x.id === res.data.id ? res.data : x)) : [...xs, res.data]));
      toast.success(editing?.id ? "Saved changes" : "Added successfully");
      setEditing(null);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save");
    } finally {
      setSaving(false);
    }
  };

  const remove = async (it) => {
    if (!window.confirm(`Delete "${it.name || it.title}"? This cannot be undone.`)) return;
    try {
      await adminApi.delete(`/${resource}/${it.id}`);
      setItems((xs) => xs.filter((x) => x.id !== it.id));
      toast.success("Deleted");
    } catch {
      toast.error("Could not delete");
    }
  };

  return { editing, setEditing, query, setQuery, saving, filtered, save, remove };
};
